import React from "react";
import { DealerLocatorIcons, DealerLocatorIconT } from "../icons/dealer-locator-icons";

import { SwarovskiOptikSegmentKey } from "@swo/shared";

type SegmentIconSvgProps = {
  segment: SwarovskiOptikSegmentKey;
  cropped: boolean | "new";
} & React.SVGProps<SVGSVGElement>;

export const SegmentIconSvg = ({ segment, cropped, ...rest }: SegmentIconSvgProps) => {
  function getComponent(): DealerLocatorIconT {
    switch (segment) {
      case "birding": {
        return cropped ? "SegmentBirdingTrimmedSvg" : "SegmentBirdingSvg";
      }
      case "hunting": {
        return cropped ? "SegmentHuntingTrimmedSvg" : "SegmentHuntingSvg";
      }
      case "outdoor": {
        return cropped ? "SegmentOutdoorTrimmedSvg" : "SegmentOutdoorSvg";
      }
      default: {
        const _: never = segment;

        return _;
      }
    }
  }

  const Component = getComponent();

  return <DealerLocatorIcons icon={Component} {...rest} />;
};
